import React from 'react';
import './TabNavigation.css';

const TabNavigation = ({ activeTab, onTabChange, showExplorerHint = false, onDismissExplorerHint }) => {
  const handleExplorerClick = () => {
    if (showExplorerHint && onDismissExplorerHint) {
      onDismissExplorerHint();
    }
    onTabChange('explorer');
  };

  return (
    <div className="tab-navigation">
      <button
        className={`tab-button ${activeTab === 'quicknotes' ? 'active' : ''}`}
        onClick={() => onTabChange('quicknotes')}
      >
        <i className="fas fa-sticky-note"></i>
        <span>My Quick Notes</span>
      </button>
      <button
        className={`tab-button tab-explorer ${activeTab === 'explorer' ? 'active' : ''} ${showExplorerHint ? 'explorer-hint-pulse' : ''}`}
        onClick={handleExplorerClick}
      >
        <i className="fas fa-map-marked-alt"></i>
        <span>My Explorer Board</span>
        {showExplorerHint && <span className="tab-badge-new">New</span>}
      </button>
    </div>
  );
};

export default TabNavigation;
